"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import SimpleScene from "./SimpleScene";

export default class MainScene extends SimpleScene {
    constructor() {
        super();

        // Attributes.
        this._playBtn = null;
        this._titleSprite = null;
    }

    init() {

        this._bgSprite = new PIXI.Sprite(Common.assets.getTexture("splash_bg"));//must go first for some reason
        super.init();

        // Title sprite.
        this._titleSprite = new PIXI.Sprite(Common.assets.getTexture("game_title"));
        this._titleSprite.anchor = new PIXI.Point(0.5, 0.5);
        this._titleSprite.position = new PIXI.Point(Common.STAGE_WIDTH * 0.5, Common.STAGE_HEIGHT * 0.5 - 45);
        //this._titleSprite.scale.set(0.9);
        this.addChild(this._titleSprite);

        // Play button.
        /*
         const btnStatesAux = new P3.ButtonStates(
         Common.assets.getTexture("btn_primary_large_off"),
         Common.assets.getTexture("btn_primary_large_over"),
         Common.assets.getTexture("btn_primary_large_down"),
         Common.assets.getTexture("icon_play_large_off")
         );*/

        this._playBtn = createButton("play_large", "primary_large");
        this._playBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._playBtn.position = new PIXI.Point(
            Common.STAGE_WIDTH * 0.5 + 325,
            Common.STAGE_HEIGHT - 110);
        this._playBtn.overSoundName = "sfx_ui_rollover_00";
        this._playBtn.downSoundName = "sfx_btn_play_start_doorbell_00";
        this._playBtn.signals.click.addOnce(this._onPlayButton_Click, this);
        this.addChild(this._playBtn);

        super.createSharedControls(this);
        this._uiTopBarSharedControls.muteBtn.visible = true;

    }

    destroy() {
        super.destroy({children: true});
        TweenMax.killAll();
    }

    animateIn() {
        this._playBtn.alpha = 0;
        this._playBtn.scale = new PIXI.Point();
        TweenMax.to(this._playBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.2});
        TweenMax.to(this._playBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.2});

        // Music.
        Common.audio.playMusic("music_mainmenu_loop_00");
    }

    //----EVENTS----//

    _onPlayButton_Click() {
        this.signals.next.dispatch(this);
    }
}
